<template>
  <div>
    <input type="radio" v-model="value" :label="label1" :value="false">
    <input type="radio" v-model="value" :label="label2" :value="true">
  </div>
</template>

<script>
export default {
  props: ['label1', 'label2', 'defaultValue'],
  data () {
    return {
      value: false
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('update', this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
  div {
    display: grid;
    grid-template-columns: repeat(2, 80px);
    align-items: center;
    justify-content: flex-start;
    width: 160px;
    gap: 0px;
    &>label{
      font-weight: 500;
      font-size: 18px;
      color: var(--color-base0);
      letter-spacing: .1em;
    }
  }
  input[type=radio] {
    margin: 0;
    width: 80px;
    height: 35px;
    appearance: none;
    background-color: #B9B9B9;
    align-items: center;
    justify-content: center;
    display: flex;
    border: none;
    &:nth-child(1) {
      border-radius: 5px 0 0 5px;
    }
    &:nth-child(2) {
      border-radius: 0 5px 5px 0;
    }
    &::before {
      color: #FFFFFF;
      content: attr(label);
      display: inline-block;
      font-weight: 700;
      font-size: 18px;
      letter-spacing: 0.1em;
      border: none;
    }
    &:nth-child(2):checked {
      background-color: var(--color-pri);
    }
    &:nth-child(1):checked {
      background-color: #E37878;
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (orientation: portrait) {}
</style>
